import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { Clock, Star } from "lucide-react";

export default function AdminConsultations() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("all");

  const load = () => {
    const params = tab && tab !== "all" ? `?status=${tab}` : "";
    api.get(`/admin/consultations${params}`, adminApi()).then(({ data }) => setItems(data));
  };
  useEffect(() => { load(); }, [tab]);  // eslint-disable-line

  return (
    <div className="font-admin-body" data-testid="admin-consultations">
      <h1 className="font-admin-head text-3xl mb-4">Konsültasyonlar</h1>
      <div className="flex gap-2 mb-4 flex-wrap">
        {[["all","Tümü"],["pending","Bekleyen"],["in_progress","Aktif"],["completed","Tamamlanan"],["cancelled","İptal"],["expired","Süresi Doldu"]].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`c-tab-${k}`} className={`px-3 py-1.5 rounded-full text-sm ${tab === k ? "bg-[#F59E0B]/20 text-[#F59E0B]" : "bg-white/5 text-white/60"}`}>{l}</button>
        ))}
      </div>

      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-white/50 uppercase tracking-wider">
            <tr className="border-b border-[#27272A]">
              <th className="p-3">Tarih</th><th className="p-3">Kullanıcı</th><th className="p-3">Falcı</th><th className="p-3">Tür</th><th className="p-3">Süre</th><th className="p-3">Ücret</th><th className="p-3">Uzatma</th><th className="p-3">Durum</th><th className="p-3">Kapatan</th><th className="p-3">Puan</th><th className="p-3">Yorum</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-b border-[#18181B]" data-testid={`c-${c.id}`}>
                <td className="p-3 text-xs text-white/60">{new Date(c.created_at).toLocaleString("tr-TR")}</td>
                <td className="p-3">{c.user_name}</td>
                <td className="p-3">{c.falci_name}</td>
                <td className="p-3 text-xs capitalize">{c.fortune_type}</td>
                <td className="p-3 tabular-nums flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-white/40" /> {c.duration_min} dk</td>
                <td className="p-3 tabular-nums text-[#F59E0B]">{c.total_charged || c.tokens_charged} 🪙</td>
                <td className="p-3 tabular-nums text-xs">{c.extension_count || 0}x</td>
                <td className="p-3"><span className={`text-xs px-2 py-0.5 rounded ${c.status === "completed" ? "bg-emerald-500/20 text-emerald-300" : c.status === "cancelled" ? "bg-red-500/20 text-red-300" : c.status === "in_progress" ? "bg-blue-500/20 text-blue-300" : "bg-amber-500/20 text-amber-300"}`}>{c.status}</span></td>
                <td className="p-3 text-xs text-white/60">{c.closed_by || "-"}</td>
                <td className="p-3">{c.user_rating ? <span className="flex items-center gap-0.5"><Star className="w-3.5 h-3.5 fill-[#F59E0B] text-[#F59E0B]" />{c.user_rating}</span> : "-"}</td>
                <td className="p-3 text-xs text-white/70 max-w-xs truncate" title={c.user_review || c.result_text}>{c.user_review || c.result_text || "-"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={11} className="p-10 text-center text-white/40">Kayıt yok.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
